// analytics/components/charts/ChartFactory.tsx
import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';
import BarChart from './BarChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
import DoughnutChart from './DoughnutChart';
import GaugeChart from './GaugeChart';
import PlaceholderChart from '../PlaceholderChart';
import { OutPatientResponse, ChartData , DistributionResponse, IAppointmentTypeDataResponse, ChartType } from '../types';
import DemographicChart from './DemographicsCharts';
import DataValue from './DataValue';
// import PatientBarChart from '../../../dashboards/Analytics/PatientsBarChart';
import { IDepartment } from '../../../../constants/types';
import PatientBarChart from './PatientsBarChart';
import MultiChart from './MultiChart';
import ProductivityTable from './ProductivityTable';
import AppointmentStatsChart from './AppointmentStatsChart';
import TypeDataTable from './TypeDataTable';
import AppointmentTypeChart from './TypeDataChart';
import WaitTimeDistributionChart from './WaitTimeDistribution';
import WaitTimeChart from './WaitTimeChart';
import DiagnosisTable from './DiagnosisTable';
import CategoryBillingTable from './CategoryBillingTable';
import PatientCategoryService from './PatientCategoryTable';

export interface ChartFactoryProps {
  type: ChartType;
  title: string;
  data: OutPatientResponse | ChartData | DistributionResponse | IAppointmentTypeDataResponse;
  id: string;
  departments:IDepartment[];
  departmentSelected:IDepartment | null;
  startDate?: number | null;
  endDate?: number | null;
}

interface BarChartProps{
  series: {
      name: string,
      count: number[]
  }[],
  title:Element,
  categories:Date[]
}

const ChartFactory: React.FC<ChartFactoryProps> = ({ type, title, data: originalData, id, departments, departmentSelected, startDate, endDate }) => {

  // If no data, show placeholder
  if (!originalData) {
    console.log('No data in chart factory', title, type, originalData);
    return <PlaceholderChart title={title} type={type} data={title}  />;
  }

  const data = originalData.chartData ? originalData.chartData : originalData;

  const categories = data.query?.map((item) => item.date) || [];
  const seriesDepartment = {
    name: title,
    count: data.trend?.totals || []
  };
  
  console.log('categories', categories, seriesDepartment);

  const renderChart = () => {
    switch (type) {
      case 'bar':
        return <BarChart data={data} title={title} categories={categories} series={seriesDepartment} type={type} />;
      case 'demographic':
        return <DemographicChart data={data} title={title} />;
      case 'data-value':
        return <DataValue data={data} title={title} type={type} value={'hopla'} size={'large'}/>;
      case 'multi-chart':
        return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={true} type="bar"/>;
      case 'patient-bar':
        return <PatientBarChart departments={departments} departmentSelected={departmentSelected} data={data} statsPerDepartment={data} title={title}  />;
      case 'bar-chart':
          return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="bar" total={data?.count} stacked={false}/>;
      case 'bar-stacked':
          return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={true} type="bar" total={data?.count} stacked={true}/>;
      case 'radar':
          return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="radar" total={data?.count} stacked={false}/>;
      case 'distribuited':
        return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="bar" total={data?.count} stacked={true} ditributed={true}/>;
      case 'horizontal-bar':
        return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={true} type="bar" total={data?.count}/>;

      case 'line':
        return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="line" total={data?.count}/>;
      case 'pie':
        return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="pie" total={data?.count}/>;
      case 'donut':
          return <MultiChart series={data?.series || []} categories={data?.categories || []} title={title} horizontal={false} type="donut" total={data?.count}/>;
      case 'appointment-stats':
            return <AppointmentStatsChart stats={data.stats} title={title} height={400}/>;
      case 'doughnut':
        return <DoughnutChart data={data} title={title} type={type} />;
      case 'gauge':
        return <GaugeChart data={data} title={title} type={type} />;
      case 'data-only':
        return <PlaceholderChart title={title} type={type} data={originalData}/>;
      case 'productivity':
        return <ProductivityTable data={data.data} title={title} type={type} stats={data.stats} department={data.department} showOptionalColumns={true}/>;
      case 'appointment-type-table':
        return <>
          <AppointmentTypeChart data={data.stats} title={title} chartType="bar"
              stacked={true}
              horizontal={true} />
          <TypeDataTable data={data.stats} title={title} type={type} />
        </>;
      case 'wait-time':
        return <>
          <WaitTimeDistributionChart data={data} title={title} chartType="bar" horizontal={false} usePercentage={true} />
          <WaitTimeChart data={data} title={title} horizontal={true} metricType="avg" />
        </>
      case 'diagnosis-table':
        return <DiagnosisTable data={data} title={title} />;
      case 'category-billing-table':
        return <CategoryBillingTable data={originalData.stats} startDate={startDate} endDate={endDate} />;
      case 'patient-category-billing':
        return <PatientCategoryService data={originalData.stats?.lines || []} startDate={startDate} endDate={endDate} />;
      default:
        return <PlaceholderChart title={title} type={type} data={data}/>;
    }
  };

  return (
    <Card>
      {/* <CardHeader title={title} /> */}
      <CardContent>
        {renderChart()}
      </CardContent>
    </Card>
  );
};

export default ChartFactory;